/**
 * Product PDP: accordion + tabs (replaces Bootstrap JS for data-bs-* in main-product).
 */
(function () {
  function initCollapse() {
    document.querySelectorAll('.product-single [data-bs-toggle="collapse"]').forEach(function (btn) {
      if (btn.dataset.pdpCollapseBound) return;
      btn.dataset.pdpCollapseBound = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var targetSel = btn.getAttribute('data-bs-target');
        if (!targetSel) return;
        var panel = document.querySelector(targetSel);
        if (!panel) return;

        var parentSel = panel.getAttribute('data-bs-parent');
        var parent = parentSel ? document.querySelector(parentSel) : null;

        if (parent) {
          parent.querySelectorAll('.accordion-collapse.show').forEach(function (open) {
            if (open !== panel) {
              open.classList.remove('show');
              var otherBtn = parent.querySelector('[data-bs-target="#' + open.id + '"]');
              if (otherBtn) otherBtn.classList.add('collapsed');
            }
          });
        }

        var isOpen = panel.classList.contains('show');
        panel.classList.toggle('show', !isOpen);
        btn.classList.toggle('collapsed', isOpen);
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  }

  function initTabs() {
    document.querySelectorAll('.product-single [data-bs-toggle="tab"]').forEach(function (btn) {
      if (btn.dataset.pdpTabBound) return;
      btn.dataset.pdpTabBound = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var targetSel = btn.getAttribute('data-bs-target');
        if (!targetSel) return;
        var pane = document.querySelector(targetSel);
        if (!pane) return;

        var tabContent = pane.closest('.tab-content');
        var nav = btn.closest('.nav-tabs');

        if (tabContent) {
          tabContent.querySelectorAll('.tab-pane').forEach(function (p) {
            p.classList.remove('show', 'active');
          });
        }
        pane.classList.add('show', 'active');

        if (nav) {
          nav.querySelectorAll('.nav-link').forEach(function (link) {
            link.classList.remove('active');
            link.setAttribute('aria-selected', 'false');
          });
        }
        btn.classList.add('active');
        btn.setAttribute('aria-selected', 'true');
      });
    });
  }

  function init() {
    initCollapse();
    initTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
